// client/src/routes/app/fiscal/index.tsx — SCR-FISC-001, with SCR-FISC-007 as `?explain=` ·
// FISC-007 (04 §8.11, §7's route tree, §9.2.3).
//
// Replaces UI-003's `PlaceholderScreen`, which named this item as its owner.
//
// TWO GATES, AND THEY ARE NOT THE SAME GATE. `Fiscal.Read` is what the API enforces (02 §6.4)
// and what §6.2 lists. The ROLE gate beside it is 04 §8.11's heading — „role `owner`/
// `accountant` — hidden from `manager`" — which no permission can express, because 03 §17.1
// grants `manager` `Fiscal.Read` and D-1236 records that the endpoints therefore answer them.
// The sidebar hides these entries from a manager; this renders SCR-SYS-403 for the URL that was
// typed anyway (§9.2.2). See D-1271.

import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';

import { RequireAnyRole, RequirePermission } from '@/components/layout/route-guards';
import { fiscalVisible } from '@/config/fiscal';
import { ObligationsScreen } from '@/features/fiscal/ObligationsScreen';
import {
  fiscalObligationsSearchSchema,
  type FiscalObligationsSearch,
} from '@/features/fiscal/search';

export const Route = createFileRoute('/app/fiscal/')({
  // Withdrawn from view with the fiscal module (D-2780): a typed or bookmarked address, or a
  // link in an old e-mail, lands on the dashboard rather than on a screen the sidebar hides.
  beforeLoad: () => {
    if (!fiscalVisible()) throw redirect({ to: '/app/dashboard' });
  },
  validateSearch: fiscalObligationsSearchSchema,
  component: FiscalScreen,
});

function FiscalScreen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Fiscal.Read">
      <RequireAnyRole roles={['owner', 'accountant']}>
        <ObligationsScreen
          search={search}
          onSearchChange={(
            next: (previous: FiscalObligationsSearch) => FiscalObligationsSearch,
          ) => {
            void navigate({ search: next });
          }}
        />
      </RequireAnyRole>
    </RequirePermission>
  );
}
